// extracted by mini-css-extract-plugin
export default {"section":"DrawdownBox_section__4FWur","downloadBox":"DrawdownBox_downloadBox__sB6ko","option":"DrawdownBox_option__9eLll","investorDrawdown":"DrawdownBox_investorDrawdown__8NSpS"};